import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PipeModule } from '../../common/pipes/pipe.module';
import { AppDownloadModule } from '../../shared/app-download/app-download.module';
import { SipPhoneCallModule } from '../../shared/sip-phone-call/sip-phone-call.module';
import { SvgCommonModule } from '../../shared/svg/svg-common.module';
import { TechnicalAlertsModule } from '../../shared/technical-alerts/technical-alerts.module';
import { UiModule } from '../../ui/ui.module';
import { MobileLabelCreateNotificationComponent } from '../components/mobile-label-create-notification/mobile-label-create-notification.component';

import { AuthorizationEnabledComponent } from './authorization-enabled/authorization-enabled.component';
import { LoginAdSliderComponent } from './login-ad-slider/login-ad-slider.component';
import { LoginFooterComponent } from './login-footer/login-footer.component';
import { LoginHeaderComponent } from './login-header/login-header.component';
import { LoginMainInformationComponent } from './login-main-info/login-main-info.component';
import { OutsideLayoutComponent } from './outside-layout/outside-layout.component';


@NgModule({
	declarations: [
		LoginFooterComponent,
		LoginHeaderComponent,
		OutsideLayoutComponent,
		LoginAdSliderComponent,
		LoginMainInformationComponent,
		AuthorizationEnabledComponent,
	],
	exports: [
		LoginFooterComponent,
		LoginHeaderComponent,
		OutsideLayoutComponent,
		LoginAdSliderComponent,
		LoginMainInformationComponent,
		AuthorizationEnabledComponent,
	],
	imports: [
		CommonModule,
		SvgCommonModule,
		SipPhoneCallModule,
		AppDownloadModule,
		PipeModule,
		UiModule,
		TechnicalAlertsModule,
		MobileLabelCreateNotificationComponent,
	],
})
export class AuthorizationLayoutModule { }
